<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<div class="card-title">Ingreso de Empresa</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<div id="stepper1" class="bs-stepper" #stepper1>
										<div class="bs-stepper-header">
											<div class="row">
												<div class="col-12">
													<div class="row">
														<div class="col-3">
															<div class="step" data-target="#form-emisor-base">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">1</span>
																	<span class="bs-stepper-label">Datos de Empresa</span>
																</button>
															</div>
														</div>
														<div class="col-3">
															<div class="step" data-target="#form-emisor-actividades">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">2</span>
																	<span class="bs-stepper-label">Actividades Economicas</span>
																</button>
															</div>
														</div>
														<div class="col-3">
															<div class="step" data-target="#form-certificado">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">3</span>
																	<span class="bs-stepper-label">Certificado Digital</span>
																</button>
															</div>
														</div>
														<div class="col-3">
															<div class="step" data-target="#form-emisor-logo">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">4</span>
																	<span class="bs-stepper-label">Logo [Opcional]</span>
																</button>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12">
													<div class="row">
														<div class="col-3">
															<div class="step" data-target="#form-pago">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">5</span>
																	<span class="bs-stepper-label">Pago del Plan</span>
																</button>
															</div>
														</div>
														<!--Este de sucursal se debe cambiar por lo de configuracion-->
														<div class="col-3">
															<div class="step" data-target="#form-configuracion" id="configuracion">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">6</span>
																	<span class="bs-stepper-label">Configuración</span>
																</button>
															</div>
														</div>
														<div class="col-3">
															<div class="step" data-target="#form-facturacion">
																<button class="step-trigger">
																	<span class="bs-stepper-circle">7</span>
																	<span class="bs-stepper-label">Datos de Facturación</span>
																</button>
															</div>
														</div>
														<!-- <div class="col-3">
                                             <div class="step" data-target="#form-folios-dte">
                                                <button class="step-trigger">
                                                   <span class="bs-stepper-circle">7</span>
                                                   <span class="bs-stepper-label">Folios [Opcional]</span>
                                                </button>
                                             </div>
                                          </div>
                                          <div class="col-3" *ngIf="user.configured">
                                             <div class="step" data-target="#form-plantillas-pdf">
                                                <button class="step-trigger">
                                                   <span class="bs-stepper-circle">8</span>
                                                   <span class="bs-stepper-label">Plantillas PDF</span>
                                                </button>
                                             </div>
                                          </div> -->
													</div>
												</div>
											</div>
										</div>
										<div class="bs-stepper-content">
											<form action="" (ngSubmit)="onSubmit()" [formGroup]="emisorSuperGroup">
												<div id="form-emisor-base" class="content fade">
													<ng-container *ngTemplateOutlet="baseEmisorForm"></ng-container>
													<button name="siguiente" id="siguiente_1" type="button" (click)="next($event, emisorBaseFormRef)" class="btn btn-primary">Siguiente</button>
												</div>

												<div id="form-emisor-actividades" class="content fade">
													<ng-container *ngTemplateOutlet="actividadForm"></ng-container>
													<button name="anterior" id="anterior_1" type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>

													<button name="siguiente" id="siguiente_2" type="button" (click)="next($event, actividadLocalFormRef)" class="btn btn-primary">Siguiente</button>
												</div>

												<div id="form-certificado" class="content fade">
													<ng-container *ngTemplateOutlet="certificadoForm"></ng-container>
													<button name="anterior" id="anterior_2" type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>

													<button name="siguiente" id="siguiente_3" type="button" (click)="validateCertificate($event)" class="btn btn-primary">Siguiente</button>
												</div>

												<div id="form-emisor-logo" class="content fade">
													<ng-container *ngTemplateOutlet="logoForm"></ng-container>
													<button name="anterior" id="anterior_3" type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>
													<button name="siguiente" id="siguiente_4" type="button" (click)="next($event, logoLocalFormRef)" class="btn btn-primary">Siguiente</button>
												</div>

												<div id="form-pago" class="content fade">
													<ng-container *ngTemplateOutlet="pagoForm"></ng-container>
													<button name="anterior" id="anterior_4" type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>
													<button name="siguiente" id="siguiente_5" type="button" (click)="next($event)" class="btn btn-primary">Siguiente</button>
												</div>
												<!--Este de sucursal se debe cambiar por lo de configuracion-->
												<div id="form-configuracion" class="content fade">
													<ng-container *ngTemplateOutlet="configuracionForm"></ng-container>
													<button name="anterior" id="anterior_5" type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>

													<button name="siguiente" id="siguiente_6" type="button" (click)="next($event, sucursalLocalFormRef)" class="btn btn-primary">Siguiente</button>
												</div>

												<div id="form-facturacion" class="content fade">
													<ng-container *ngTemplateOutlet="facturacionForm"></ng-container>
													<button name="anterior" id="anterior_6" type="button" class="btn btn-default mt-5 mr-5" (click)="previous()">Anterior</button>
													<button id="enviar" type="submit" class="btn btn-success mt-5">Enviar</button>
													<!-- <button type="button" (click)="next($event)" class="btn btn-primary">Siguiente</button> -->
												</div>
												<!-- <div id="form-folios-dte" class="content fade">
                                       <ng-container *ngTemplateOutlet="foliosForm"></ng-container>
                                       <button type="button" class="btn btn-default mr-5" (click)="previous()">Anterior</button>

                                       <button type="button" (click)="next($event)" class="btn btn-primary">Siguiente</button>
                                    </div> -->
												<!-- <div id="form-plantillas-pdf" class="content fade">
                                       <ng-container *ngTemplateOutlet="plantillasForm"></ng-container>
                                       <button type="button" class="btn btn-default mr-5 mt-5" (click)="previous()">Anterior</button>

                                       <button class="btn btn-success mt-5">Enviar</button>
                                    </div> -->
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #baseEmisorForm [formGroup]="emisorSuperGroup">
	<div id="wizStepDatosEmpresa">
		<h4>Datos de la empresa</h4>
		<form formGroupName="base" #emisorBaseFormRef>
			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">Rut Empresa</label>
				<div class="col-2">
					<input
						type="text"
						name="rutString"
						id="rutEmpresa"
						placeholder="12.345.678-9"
						class="form-control"
						formControlName="rutString"
						maxlength="12"
						appFormatRut
						(blur)="comprobar($event)"
						autocomplete="new-password"
						required
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('rutString').invalid
						}" />
					<div *ngIf="(submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('rutString').invalid) || (emisorSuperGroup.controls.base.get('rutString').invalid && emisorSuperGroup.controls.base.get('rutString').touched)" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('rutString').errors.required">Campo obligatorio</div>
						<div *ngIf="emisorSuperGroup.controls.base.get('rutString').errors.VerificacionRutValidator" class="invalid-feedback">Rut Invalido</div>
					</div>
				</div>
				<label class="col-2 label-control" for="projectinput1">Razón Social</label>
				<div class="col-6">
					<input
						type="text"
						name="razonSocial"
						id="razonSocial"
						placeholder="Razón social. Nombre tributario/legal de tu empresa."
						class="form-control"
						formControlName="razonSocial"
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('razonSocial').invalid
						}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('razonSocial').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('razonSocial').errors.required">Campo obligatorio</div>
					</div>
				</div>
			</div>
			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">Rut Representante Legal</label>
				<div class="col-2">
					<input
						type="text"
						name="rutRepresentanteLegal"
						id="repLegal"
						placeholder="12.345.678-9"
						class="form-control"
						formControlName="rutRepresentanteLegal"
						maxlength="12"
						required
						(blur)="setRepresentanteLegal()"
						appVerificaRut
						appFormatRut
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('rutRepresentanteLegal').invalid
						}" />
					<div *ngIf="(submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('rutRepresentanteLegal').invalid) || (emisorSuperGroup.controls.base.get('rutRepresentanteLegal').invalid && emisorSuperGroup.controls.base.get('rutRepresentanteLegal').touched)" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('rutRepresentanteLegal').errors.required">Campo obligatorio</div>
						<div *ngIf="emisorSuperGroup.controls.base.get('rutRepresentanteLegal').errors.VerificacionRutValidator" class="invalid-feedback">Rut Invalido</div>
					</div>
				</div>
				<label class="col-2 label-control" for="projectinput1">Giro</label>
				<div class="col-6">
					<input
						type="text"
						name="giro"
						id="giro"
						placeholder="Actividad de tu empresa"
						class="form-control"
						formControlName="giro"
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('giro').invalid
						}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('giro').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('giro').errors.required">Campo obligatorio</div>
					</div>
				</div>
			</div>
			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">E-mail</label>
				<div class="col-2">
					<input
						type="email"
						name="correoFact"
						id="emailFact"
						placeholder="Correo de contacto"
						class="form-control"
						formControlName="correoFact"
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('correoFact').invalid
						}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('correoFact').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('correoFact').errors.required">Campo obligatorio</div>
						<div *ngIf="emisorSuperGroup.controls.base.get('correoFact').hasError('wrongEmail')">Correo inválido</div>
						<div *ngIf="emisorSuperGroup.controls.base.get('correoFact').hasError('placeholderEmail')">Debes ingresar un correo válido; no se permite usar sincorreo@sincorreo.cl.</div>
					</div>
				</div>
				<label class="col-2 label-control" for="projectinput1">Dirección Facturación</label>
				<div class="col-6">
					<div *ngIf="showDomiciliosCombo && domiciliosFromSii.length > 1">
						<ng-select
							[items]="domiciliosFromSii"
							[addTag]="agregarDireccionPersonalizada"
							[clearable]="false"
							[searchable]="true"
							placeholder="Seleccione o escriba una dirección"
							addTagText="Presione Enter para agregar esta dirección"
							bindLabel="direccion"
							[(ngModel)]="domicilioSeleccionado"
							[ngModelOptions]="{ standalone: true }"
							(change)="seleccionarDomicilio($event)"
							[required]="true"
							[ngClass]="{
								'is-invalid': submittedChildrenFormsArray[0] && !domicilioSeleccionado
							}">
							<ng-template ng-option-tmp let-item="item">
								<div>
									<strong>{{ item.direccion }}</strong>
									<div class="small text-muted">{{ item.ciudad }} - {{ item.comuna }}</div>
								</div>
							</ng-template>
						</ng-select>
						<small class="text-muted">Puede seleccionar una dirección o escribir una nueva</small>
						<div *ngIf="submittedChildrenFormsArray[0] && !domicilioSeleccionado" class="invalid-feedback d-block">Debe seleccionar o ingresar una dirección</div>
					</div>

					<div *ngIf="!showDomiciliosCombo || domiciliosFromSii.length <= 1">
						<input
							type="text"
							name="dirFact"
							id="DireccionFact"
							placeholder="Dirección de tu casa matriz"
							class="form-control"
							formControlName="dirFact"
							(blur)="setAddress()"
							[ngClass]="{
								'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('dirFact').invalid
							}"
							required />
						<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('dirFact').invalid" class="invalid-feedback">
							<div *ngIf="emisorSuperGroup.controls.base.get('dirFact').errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">Ciudad</label>
				<div class="col-2">
					<input
						type="text"
						name="ciudad"
						id="wizCiudad"
						placeholder=""
						maxlength="100"
						class="form-control"
						formControlName="ciudad"
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('ciudad').invalid
						}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('ciudad').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('ciudad').errors.required">Campo obligatorio</div>
					</div>
				</div>
				<label class="col-2 label-control" for="projectinput1">
						Nombre sucursal
						<i class="fa fa-question-circle ml-1"
							ngbTooltip="Ejemplo: Casa matriz."
							container="body"></i>
					</label>
				<div class="col-6">
					<input
						type="text"
						name="nombre"
						placeholder="Ingresar nombre"
						class="form-control"
						formControlName="nombreSucursal"
						maxlength="50"
						[ngClass]="{'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('nombreSucursal').invalid}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('nombreSucursal').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('nombreSucursal').errors.required">Campo obligatorio</div>
					</div>
				</div>
				
			</div>
			<!-- <div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">Comuna</label>
				<div class="col-4">
				<input type="text" name="comuna" placeholder="Ingresar comuna" class="form-control" formControlName="comuna" [ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('comuna').invalid
					}" required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('comuna').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.base.get('comuna').errors.required">Campo obligatorio</div>
				</div>
				</div>
			</div> -->

			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="projectinput1">Comuna</label>
				<div class="col-2">
					<input
						type="text"
						name="comuna"
						id="wizComuna"
						placeholder=""
						class="form-control"
						maxlength="100"
						formControlName="comuna"
						[ngClass]="{
							'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('comuna').invalid
						}"
						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('comuna').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('comuna').errors.required">Campo obligatorio</div>
					</div>
				</div>
				<label class="col-2 label-control" for="projectinput1">Dirección sucursal</label>
				<div class="col-6">
					<input
						type="text"
						name="direccion"
						placeholder="Ingresar dirección"
						class="form-control"
						formControlName="direccionSucursal"
						[ngClass]="{'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('direccionSucursal').invalid}"

						required />
					<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('direccionSucursal').invalid" class="invalid-feedback">
						<div *ngIf="emisorSuperGroup.controls.base.get('direccionSucursal').errors.required">Campo obligatorio</div>
					</div>
				</div>
			</div>
			<div class="form-group row mx-auto" style="align-items: baseline">
				<label class="col-2 label-control" for="wizTelefono">Telefono</label>

				<div class="col-2">
					<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">+56</span>
					</div>

					<input
						oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
						maxlength="9"
						min="1"
						type="number"
						name="telefono"
						id="wizTelefono"
						formControlName="telefono"
						placeholder="911111111"
						class="form-control"
						[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('telefono').invalid
						}"
						required
					/>
					</div>
				</div>
			</div>

		</form>
	</div>
</ng-template>

<!--Este de sucursal se debe cambiar por lo de configuracion-->
<ng-template #configuracionForm [formGroup]="emisorSuperGroup">
  <div class="row" formGroupName="configuracion" id="wizStepConfiguracion">
    <div class="col-12">
      <h4>Configuración</h4>
    </div>

    <div class="col-12 mt-4">
      <div class="form-group row mx-auto" style="align-items: baseline">
        <a class="col-2 label-control" style="text-decoration: underline" for="projectinput1" (click)="openModalSII(modalSII)">Fecha Resolución</a>
        <div class="col-4">
          <input type="date"
                 class="form-control"
                 formControlName="fechaResol"
                 [ngClass]="{'is-invalid': submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('fechaResol').invalid}" />
          <div *ngIf="submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('fechaResol').invalid" class="invalid-feedback d-block">
            Campo obligatorio
          </div>
        </div>

        <a class="col-2 label-control" style="text-decoration: underline" for="projectinput1" (click)="openModalSII(modalSII)">N° Resolución</a>
        <div class="col-4">
					<input type="number"
								 class="form-control"
								 formControlName="nroResol"
								 max="999"
								 (input)="restrictNroResolLength($event)"
								 [ngClass]="{'is-invalid': submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('nroResol').invalid}" />
					<div *ngIf="submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('nroResol').invalid" class="invalid-feedback d-block">
						Campo obligatorio o inválido (sólo números, máximo 3 dígitos)
					</div>
        </div>
      </div>

      <div class="form-group row mx-auto mt-3" style="align-items: baseline">
        <label class="col-2 label-control">
          Ambiente
          <i class="fa fa-question-circle ml-1"
            ngbTooltip="Estos datos dependerán del ambiente en el que trabajes. Selecciona 'PRUEBAS QA' si quieres iniciar en modo pruebas. Selecciona 'PRODUCCIÓN' si estás listo para emitir documentos reales."
            container="body"></i>
        </label>
        <div class="col-4" id="wizStepAmbiente">
          <ng-select
            [items]="environmentType"
            bindLabel="nombre"
            placeholder="Seleccione ambiente"
            formControlName="ambiente">
          </ng-select>
          <div *ngIf="submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('ambiente').invalid" class="invalid-feedback d-block">
            Campo obligatorio
          </div>
        </div>

        <label class="col-2 label-control">Unidad S.I.I</label>
        <div class="col-4">
          <input type="text"
                 class="form-control"
                 placeholder="Nombre de la Unidad del S.I.I."
                 formControlName="unidadSII"
                 maxlength="30"
                 [ngClass]="{'is-invalid': submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('unidadSII').invalid}" />
          <small> Corresponde a la dirección regional o unidad del SII a la que pertenece el emisor. <a target="_blank" href="https://www.sii.cl/ayudas/asistencia/oficinas/3048-3049.html">Consulta aquí el tuyo.</a></small>
          <div *ngIf="submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.get('unidadSII').invalid" class="invalid-feedback d-block">
            Campo obligatorio
          </div>
        </div>
      </div>

      <div class="form-group row mx-auto mt-3" style="align-items: baseline">
		<label class="col-2 label-control">Password de la empresa en el S.I.I. (opcional)</label>
        <div class="col-4" id="wizPassSII">
          <input type="password"
                 class="form-control"
                 formControlName="passwordSii"
                 autocomplete="new-password" />
          <small class="text-muted">
            Para el acceso a las boletas de honorarios. No es obligatorio.
          </small>
        </div>

        <label class="col-2 label-control">Envío automático de correos <br> <small class="text-muted d-block mt-2">
      Esta configuración podrá ser modificada posteriormente desde la sección de configuración de su empresa.
    </small></label>
        <div class="col-4 d-flex align-items-center">
          	<div class="custom-control custom-checkbox">
				<input type="checkbox"
					class="custom-control-input"
					id="envioCorreosCheck"
					formControlName="envioAutomaticoCorreos" />
				<label class="custom-control-label" for="envioCorreosCheck"></label>
          	</div>
			<i class="fa fa-question-circle ml-2"
				ngbTooltip="Si esta opción está activada, SimpleFactura enviará automáticamente por correo electrónico el DTE emitido a la casilla del cliente receptor.
					Si la desactiva, el sistema no realizará este envío y será su responsabilidad remitir el documento manualmente desde el mantenedor de documentos emitidos o gestionarlo por medios externos"
				container="body">
			</i>
        </div>
      </div>
    </div>
    <div *ngIf="submittedChildrenFormsArray[5] && emisorSuperGroup.controls.configuracion.invalid"
         class="alert alert-danger mt-3" style="border-left: 4px solid #dc3545; border-radius: 6px;">
      <i class="fa fa-exclamation-circle mr-1"></i>
      Debe completar los campos obligatorios de Configuración SII para continuar: Fecha de Resolución, N° de Resolución y Unidad SII.
    </div>
  </div>
</ng-template>


<ng-template #actividadForm [formGroup]="emisorSuperGroup">
	<div formGroupName="actividades" #actividadLocalFormRef id="wizStepActividadEco">
		<h4>Asignar Actividades Económicas</h4>
		<div class="row pt-5 ml-1 mb-5">
			<label for="" class="col-3 label-control">Actividades Económicas</label>
			<div class="col-7">
				<ng-select formControlName="actividadEconomica" [items]="economicActivitiesSource" [clearable]="true" (blur)="filtro()" id="wizActEconomic" placeholder="Seleccione actividad económica" bindLabel="displayText"></ng-select>
			</div>
			<div class="col-1 ml-1">
				<button *ngIf="permissions.getPermission('30-80-19-10').asignado" type="button" id="wizAddActividad" class="btn btn-success" (click)="addEconomicActivityToList()">Agregar</button>
			</div>
		</div>
		<div *ngIf="economicActivitiesList.length > 0">
			<h4>Actividades Económicas Asignadas</h4>
			<table class="table">
				<thead>
					<tr>
						<td>descripcion</td>
						<td>Acción</td>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of economicActivitiesList; let index = index">
						<td>{{ item.codigo }} - {{ item.descripcion }}</td>
						<td>
							<a *ngIf="permissions.getPermission('30-80-19-12').asignado" ngbTooltip="Quitar " class="primary edit mr-1 mrless" (click)="deleteItem(index)">
								<div class="icon-circle bg-danger text-center align-middle pt-info-button">
									<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
								</div>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="submittedChildrenFormsArray[1] && emisorSuperGroup.controls.actividades.get('listaActividadesEconomicas').invalid" class="invalid-feedback d-block text-danger mt-2">
			<i class="fa fa-exclamation-circle mr-1"></i>
			<span *ngIf="emisorSuperGroup.controls.actividades.get('listaActividadesEconomicas').errors?.required">
				Debe agregar al menos una actividad económica para continuar.
			</span>
		</div>
	</div>
</ng-template>

<ng-template #certificadoForm [formGroup]="emisorSuperGroup">
	<h4 class="d-flex align-items-center">
		<span class="me-2">Seleccionar Certificado Digital</span>
		<i class="fa fa-question-circle ml-1 text-muted" style="font-size: 0.8em; cursor: pointer;"
			#certPopover="ngbPopover"
			[ngbPopover]="certificadoInfo"
			popoverTitle="¿Qué certificado debo cargar?"
			triggers="manual"
			[autoClose]="false"
			placement="right"
			container="body"
			(mouseenter)="abrirCertPopover()"
			(mouseleave)="programarCierreCertPopover()"></i>
	</h4>
	<ng-template #certificadoInfo>
		<small (mouseenter)="abrirCertPopover()" (mouseleave)="programarCierreCertPopover()">
			Es importante agregar el certificado digital del representante legal de la empresa,
			en caso de que quieras agregar certificaciones. Si es solo usuario autorizado,
			asegúrate de que tenga los permisos necesarios para operar en SimpleFactura;
			puedes verificar en
			<a href="https://zeusr.sii.cl/AUT2000/InicioAutenticacion/IngresoRutClave.html?https://palena.sii.cl/cvc_cgi/dte/eu_enrola_usuarios"
				target="_blank" rel="noopener">este enlace</a>.
		</small>
	</ng-template>
	<div style="display:flex; align-items:center; gap:20px; margin-bottom:24px; flex-wrap:wrap;">
		<h4 style="margin:0; white-space:nowrap;">Seleccionar Certificado Digital</h4>
		<div style="display:flex; align-items:flex-start; gap:10px; background:#eef4ff; border-left:4px solid #3b5de7; border-radius:6px; padding:12px 16px; flex:1; min-width:280px;">
			<span style="font-size:20px; color:#3b5de7; flex-shrink:0; margin-top:1px;">&#9432;</span>
			<div style="font-size:0.88rem; color:#2d3748; line-height:1.5;">
				Para emitir y certificar DTEs, se requiere el certificado digital del <strong>Representante Legal</strong> de la empresa.<br>
				Si prefieres usar un <strong>usuario autorizado</strong>, consulta el
				<a href="https://www.canva.com/design/DAHLdEQhpI8/XxHHavrsIocAy-gy-EPQRw/view?utlId=he5697720de#1" target="_blank" rel="noopener noreferrer"
					style="color:#3b5de7; font-weight:600; text-decoration:underline;">instructivo para asignar permisos en SimpleFactura</a>.
			</div>
		</div>
	</div>
	<div formGroupName="certificado" #certificadoFormRef id="wizStepCertificadoDigital">
		<div class="form-group row mx-auto">
			<div class="col-3">Archivo de Certificado (.pfx)</div>
			<div class="col-9">
				<div *ngIf="certificadoRestaurado" class="alert alert-info py-2">
					Se restauró el certificado del borrador. Puedes continuar o reemplazarlo por otro archivo.
				</div>
				<ngx-dropzone #drop (change)="onFileChangeCER($event)" [multiple]="false">
					<ngx-dropzone-label class="px-5">
						<i class="flaticon-upload"></i>

						<p>Arrastra o selecciona el certificado digital.</p>

						<p>El formato del archivo debe ser .pfx</p>
					</ngx-dropzone-label>
					<ngx-dropzone-preview *ngFor="let f of certificadoFilesArray" [removable]="true" (removed)="onRemoveCertificaddoArray(f)">
						<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
					</ngx-dropzone-preview>
				</ngx-dropzone>
				<div *ngIf="submittedChildrenFormsArray[3] && emisorSuperGroup.controls.certificado.get('file').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.certificado.get('file').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>

		<div class="form-group row mx-auto">
			<div class="col-3">Rut del certificado</div>
			<div class="col-9">
				<input
					type="text"
					name="rutString"
					placeholder="12.345.678-9"
					class="form-control"
					formControlName="rutString"
					maxlength="12"
					appFormatRut
					autocomplete="new-password"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[3] && emisorSuperGroup.controls.certificado.get('rutString').invalid && !user.isPartner
					}" />
				<div *ngIf="(submittedChildrenFormsArray[3] || emisorSuperGroup.controls.certificado.get('rutString').dirty) && emisorSuperGroup.controls.certificado.get('rutString').invalid && !user.isPartner" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.certificado.get('rutString').errors.VerificacionRutValidator" class="invalid-feedback">Rut Invalido</div>
					<div *ngIf="emisorSuperGroup.controls.certificado.get('rutString').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto">
			<div class="col-3">Password del certificado</div>
			<div class="col-9">
				<input
					type="password"
					name="password"
					id="wizPassCert"
					placeholder="Ingresar contraseña del archivo"
					class="form-control"
					formControlName="password"
					autocomplete="new-password"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[3] && emisorSuperGroup.controls.certificado.get('password').invalid && !user.isPartner
					}" />
				<div *ngIf="submittedChildrenFormsArray[3] && emisorSuperGroup.controls.certificado.get('password').invalid && !user.isPartner" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.certificado.get('password').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-0 align-items-center" *ngIf="!isReseller">
			<div class="col-3">
				<p class="mb-0"><strong>¿Deseas comprar un certificado digital?</strong></p>
			</div>
			<div class="col-1">
				<div class="btn-group btn-group-sm" role="group">
					<button type="button" class="btn" [ngClass]="{ 'btn-primary': mostrarOpcionesCertificado, 'btn-outline-primary': !mostrarOpcionesCertificado }" (click)="cambiarOpcionCertificado(true)" [disabled]="compraCertificado.comprar">Sí</button>
					<button type="button" class="btn" [ngClass]="{ 'btn-primary': !mostrarOpcionesCertificado, 'btn-outline-primary': mostrarOpcionesCertificado }" (click)="cambiarOpcionCertificado(false)" [disabled]="compraCertificado.comprar">No</button>
				</div>
			</div>
			<div class="col-8" *ngIf="mostrarOpcionesCertificado && !compraCertificado.comprar">
				<div class="d-flex align-items-center justify-content-evenly">
					<div class="mr-6">
						<div class="input-group input-group-sm">
							<div class="input-group-prepend">
								<span class="input-group-text">Duración:</span>
							</div>
							<select class="form-control form-control-sm" formControlName="duracion" (change)="recalcularPrecioCertificado()">
								<option [ngValue]="null" disabled>Seleccione…</option>
								<option [ngValue]="1">1 año</option>
								<option [ngValue]="2">2 años</option>
								<option [ngValue]="3">3 años</option>
							</select>
							<div class="input-group-append" *ngIf="certificadoDuracion">
								<span class="input-group-text"> {{ compraCertificado.preciobase | currency : "CLP" : "symbol" : "1.0-0" : "es" }} + IVA </span>
							</div>
						</div>
					</div>
					<div class="mr-6">
						<div class="custom-control custom-checkbox text-nowrap">
							<input type="checkbox" class="custom-control-input" id="garantiaCheck" formControlName="garantia" (change)="recalcularPrecioCertificado()" />
							<label class="custom-control-label" for="garantiaCheck">Incluir garantía de recuperación</label>
							<i class="fa fa-question-circle ml-1" [ngbTooltip]="tooltipContent" container="body"></i>
						</div>
						<small class="text-muted" *ngIf="certificadoDuracion"> Valor garantía {{ compraCertificado.precioGarantia | currency : "CLP" : "symbol" : "1.0-0" : "es" }} + IVA </small>
					</div>
					<div>
						<button type="button" class="btn btn-sm btn-primary" [disabled]="!certificadoDuracion" (click)="guardarCertificado()"><fa-icon [icon]="'shopping-cart'"></fa-icon> Añadir al carrito</button>
					</div>
				</div>
			</div>

			<div class="col-7" *ngIf="compraCertificado.comprar">
				<div class="card border-primary shadow-sm mb-0">
					<div class="card-body p-2">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex align-items-center">
								<h6 class="mb-0 text-primary mr-6">Certificado Digital</h6>
								<small>
									Duración: <strong>{{ compraCertificado.duracion }} año(s)</strong>
									<span *ngIf="compraCertificado.garantia" class="badge badge-info ml-1">Con garantía</span>
								</small>
							</div>
							<button type="button" class="btn btn-sm btn-light rounded-pill" (click)="onEliminarCert()"><i class="fa fa-times text-danger"></i> Eliminar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-0 align-items-center" *ngIf="isReseller">
			<div class="col-12 mt-3">
				<small>
					<strong>Importante:</strong> Como tu cuenta opera bajo modalidad Partner, la compra de Certificado Digital no se realiza durante la creación de la empresa. Si necesitas adquirir uno, podrás hacerlo una vez finalizada la creación desde: <strong>Configuración → Certificados Digitales</strong>.
				</small>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #tooltipContent>
	<div class="tooltip-content">
		<p class="mb-0">Garantía de Recuperación: Puedes añadir la garantía de recuperación para descargar tu certificado las veces que necesites desde tu panel, sin un costo adicional.</p>
	</div>
</ng-template>

<ng-template #logoForm [formGroup]="emisorSuperGroup">
	<div formGroupName="logo" #logoLocalFormRef id="wizStepLogo">
		<div class="modal-body">
			<div class="row mb-3">
				<div class="col-6">
					<div class="text-center" *ngIf="logoRequest.logoFile">
						<p class="text-muted mb-2"><small><strong>Preview Logo Documentos:</strong></small></p>
						<img [src]="'data:image/png;base64,' + logoRequest.logoFile" alt="logo documentos" class="img-thumbnail" style="max-width: 150px; max-height: 150px; object-fit: contain;" />
					</div>
				</div>
				<div class="col-6">
					<div class="text-center" *ngIf="logoLoginPreview">
						<p class="text-muted mb-2"><small><strong>Preview Logo Login:</strong></small></p>
						<div class="login-preview-frame">
							<img [src]="logoLoginPreview" alt="logo login preview" style="max-width: 150px; max-height: 150px; object-fit: contain;" />
						</div>
					</div>
				</div>
			</div>
			<div class="container-fluid">
				<div class="row">
					<div class="col-6">
						<div class="form-group position-relative">
							<label class="label-control mb-3"><strong>Logo para Documentos</strong></label>
							<ngx-dropzone class="mx-auto" (change)="onLogoFileChange($event)" maxFileSize="2097152" accept="image/jpg,image/jpeg,image/png" multiple="false">
								<ngx-dropzone-label class="px-3">
									<i class="flaticon-upload"></i>
									<p>Arrastra o selecciona un archivo con la imagen del logo a utilizar</p>
									<p><small>Formato: .png o .jpg</small></p>
								</ngx-dropzone-label>
								<ngx-dropzone-preview *ngFor="let f of logosFilesArray" [removable]="true" (removed)="onRemoveLogo(f)">
									<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
								</ngx-dropzone-preview>
							</ngx-dropzone>

							<div *ngIf="submittedChildrenFormsArray[5] && (emisorSuperGroup.controls.logo.get('logoFile').invalid || emisorSuperGroup.controls.logo.get('logoFile').dirty)" class="invalid-feedback">
								<div *ngIf="emisorSuperGroup.controls.logo.get('logoFile').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form-group position-relative">
							<label class="label-control mb-3"><strong>Logo para Login (Publicitario)</strong></label>
							<ngx-dropzone class="mx-auto" (change)="onSelectLoginLogo($event)" maxFileSize="102400" accept="image/png" multiple="false">
								<ngx-dropzone-label class="px-3">
									<i class="flaticon-upload"></i>
									<p>Opcional: Sube tu propio logo para el login</p>
									<p class="text-muted"><small>Formato PNG, menor a 100 KB</small></p>
								</ngx-dropzone-label>
								<ngx-dropzone-preview *ngFor="let f of loginLogoFilesArray" [removable]="true" (removed)="onRemoveLoginLogo(f)">
									<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
								</ngx-dropzone-preview>
							</ngx-dropzone>
						</div>
						<div class="form-group position-relative mx-auto mt-4">
							<div class="row">
								<div class="col-12">
									<div class="checkbox-inline">
										<label class="checkbox checkbox-outline">
											<input type="checkbox" formControlName="permisoPublicitario" />
											<span></span>
											Permito que se use este logo con fines publicitarios
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #pagoForm>
	<h4>Plan de la empresa</h4>
	<app-payment-emisor (actualizarCertificaciones)="actualizarCert($event)" (actualizarResumen)="actualizarResumen($event)" [compraCertificado]="compraCertificado" [resumenBorrador]="resumenBorrador" [codigosCertificacionesBorrador]="codigosCertificacionesBorrador"> </app-payment-emisor>
</ng-template>

<ng-template #facturacionForm [formGroup]="emisorSuperGroup">
	<h4>Datos de Facturación</h4>

	<form *ngIf="!user.isPartner" formGroupName="facturacion" id="wizStepDatosFacturacion">
		<div class="row pt-5 ml-1 mb-5">
			<label for="" class="col-4 label-control">Empresa a la cual se emitirá la factura</label>
			<div class="col-8">
				<ng-select [items]="empresasFacturacionSource" [clearable]="true" (change)="onValueChangeComboEmpresa($event)" formControlName="empresaSeleccionada" (blur)="filtroEmpresasFacturacion()" placeholder="Seleccione empresa" bindLabel="razonSocial"></ng-select>
			</div>
		</div>
		<div class="row pt-5 ml-1 mb-5">
			<div class="col-12">
				<input type="checkbox" id="checkReUseData" (change)="reuseData($event.target.checked)" />
				<label class="label-control" for="checkReUseData">Usar los mismos datos de la empresa</label>
			</div>
		</div>
		<div class="form-group row mx-auto" style="align-items: baseline">
			<label class="col-2 label-control" for="projectinput1">Rut Empresa</label>
			<div class="col-2">
				<input
					type="text"
					name="rut"
					placeholder="12.345.678-9"
					class="form-control"
					formControlName="rutString"
					maxlength="12"
					appFormatRut
					required
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('rutString').invalid
					}" />
				<div *ngIf="(submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('rutString').invalid) || (emisorSuperGroup.controls.facturacion.get('rutString').invalid && emisorSuperGroup.controls.base.get('rutString').touched)" class="invalid-feedback">
					<!-- <div *ngIf="emisorSuperGroup.controls.facturacion.get('rutString').errors.rutNoValido" class="invalid-feedback">Rut Invalido</div> -->
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('rutString').errors.VerificacionRutValidator" class="invalid-feedback">Rut Invalido</div>
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('rutString').errors.required">Campo obligatorio</div>
				</div>
			</div>
			<label class="col-2 label-control" for="projectinput1">Razón Social</label>
			<div class="col-6">
				<input
					type="text"
					name="razonSocial"
					placeholder="Razón social. Nombre tributario/legal de tu empresa."
					class="form-control"
					formControlName="razonSocial"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('razonSocial').invalid
					}"
					required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('razonSocial').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('razonSocial').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto" style="align-items: baseline">
			<label class="col-2 label-control" for="projectinput1">E-mail</label>
			<div class="col-2">
				<input
					type="email"
					name="correoFact"
					placeholder="Correo de contacto"
					class="form-control"
					formControlName="correoFact"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('correoFact').invalid
					}"
					required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('correoFact').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('correoFact').errors.required">Campo obligatorio</div>
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('correoFact').hasError('wrongEmail')">Correo inválido</div>
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('correoFact').hasError('placeholderEmail')">Debes ingresar un correo válido; no se permite usar sincorreo@sincorreo.cl.</div>
				</div>
			</div>
			<label class="col-2 label-control" for="projectinput1">Giro</label>
			<div class="col-6">
				<input
					type="text"
					name="giro"
					placeholder="Actividad de tu empresa"
					class="form-control"
					formControlName="giro"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('giro').invalid
					}"
					required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('giro').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('giro').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto" style="align-items: baseline">
			<label class="col-2 label-control" for="projectinput1">Dirección</label>
			<div class="col-6">
				<input
					type="text"
					name="dirFact"
					placeholder="Dirección de tu casa matriz"
					class="form-control"
					formControlName="dirFact"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('dirFact').invalid
					}"
					required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('dirFact').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('dirFact').errors.required">Campo obligatorio</div>
				</div>
			</div>
		</div>
		<div class="form-group row mx-auto" style="align-items: baseline">
			<!-- <label class="col-2 label-control" for="projectinput1">Ciudad</label>
         <div class="col-2">
            <input
               type="text"
               name="ciudad"
               placeholder=""
               class="form-control"
               formControlName="ciudad"
               [ngClass]="{
                  'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('ciudad').invalid
               }"
               required
            />
            <div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.base.get('ciudad').invalid" class="invalid-feedback">
               <div *ngIf="emisorSuperGroup.controls.base.get('ciudad').errors.required">Campo obligatorio</div>
            </div>
         </div> -->
			<label class="col-2 label-control" for="projectinput1">Comuna</label>
			<div class="col-2">
				<input
					type="text"
					name="comuna"
					placeholder=""
					class="form-control"
					maxlength="50"
					formControlName="comuna"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('comuna').invalid
					}"
					required />
				<div *ngIf="submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('comuna').invalid" class="invalid-feedback">
					<div *ngIf="emisorSuperGroup.controls.facturacion.get('comuna').errors.required">Campo obligatorio</div>
				</div>
			</div>
			<label class="col-2 label-control" for="projectinput1">Telefono</label>
			<div class="col-2" class="d-flex align-items-center">
				<span style="margin-right: 5px">+56</span>
				<input
					oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
					maxlength="9"
					min="1"
					type="number"
					name="telefono"
					formControlName="telefono"
					placeholder="962212767"
					class="form-control"
					[ngClass]="{
						'is-invalid': submittedChildrenFormsArray[0] && emisorSuperGroup.controls.facturacion.get('telefono').invalid
					}"
					required />
			</div>
		</div>
	</form>

	<div *ngIf="user.isPartner">No aplica</div>
</ng-template>

<ng-template #modalSII let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Cómo obtener la fecha y número de resolución</div>
				<div class="modal-wizard-desc">Paso a paso</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="form-group row mx-auto">
				<div class="col-12 mb-3">
					<ul class="list list-icons list-primary mb-0">
						<li>Si es primera vez que emitirás documentos electrónicos: <a target="_blank" href="https://www.sii.cl/servicios_online/1039-postulacion-1184.html">Postula aquí</a></li>
						<li>Para los datos en el ambiente de pruebas: <a target="_blank" href="https://maullin.sii.cl/cvc_cgi/dte/ad_empresa1">Ingresa aquí</a></li>
						<li>Para los datos en el ambiente de producción: <a target="_blank" href="https://palena.sii.cl/cvc_cgi/dte/ad_empresa1">Ingresa aquí</a></li>
					</ul>
				</div>
				<div class="col-12">
					<img class="img-fluid" src="./assets/media/gifs/datosResolucion.gif" />
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div class="form-group position-relative has-icon-left mb-0">
				<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
					<span class="d-none d-lg-block">Cerrar</span>
				</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #certificacionFechaForm let-d="dismiss" let-c="close">
	<div class="modal-header">
		<div class="modal-wizard-label">
			<div class="modal-wizard-title">Fecha de Certificación</div>
		</div>
		<button type="button" class="close" (click)="d('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<label class="font-weight-bold mb-3">Seleccione la fecha de inicio del proceso:</label>
		<input type="date" class="form-control" [(ngModel)]="fechaCertificacion" [min]="fechaActual.format('YYYY-MM-DD')" />
		<small class="text-muted d-block mt-2">La activación de las certificaciones se completará entre 3 a 5 días hábiles a partir de la fecha seleccionada.</small>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="d('Cross click')">Cancelar</button>
		<button type="button" class="btn btn-primary" [disabled]="!hayCertificacionesSeleccionadas" (click)="c('confirm')">Continuar</button>
	</div>
</ng-template>
